import React from "react";
import styles from "./tem_two_ranking.module.scss";

export const TemTwoRanking = () => {
  return (
    <section className={styles.section_ranking}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2 className={styles.heading}>Ranking</h2>
          <div className={styles.sub_heading}>University Rankings</div>

          <ul className={styles.rankings}>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
          </ul>

          <div className={styles.sub_heading}>Course Rankings</div>
          <div className={styles.course_heading}>Business Courses</div>
          <ul className={styles.rankings}>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
          </ul>
          <div className={styles.course_heading}>Business Courses</div>
          <ul className={styles.rankings}>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
            <li className={styles.ranking}>
              <span className={styles.number}>#1</span>
              <div className={styles.rank}>
                <span>Universities Rankings </span>
                <span>- ARWU (Shanghai Ranking) 2020</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TemTwoRanking;
